/**
 * Token 存储抽象（localStorage）
 */
export const STORAGE_KEYS = {
    ACCESS: 'jwt_access_token',
    REFRESH: 'jwt_refresh_token'
}

export const tokenStorage = {
    getAccessToken(): string | null {
        return localStorage.getItem(STORAGE_KEYS.ACCESS)
    },
    setAccessToken(token: string | null) {
        if (token === null) {
            localStorage.removeItem(STORAGE_KEYS.ACCESS)
        } else {
            localStorage.setItem(STORAGE_KEYS.ACCESS, token)
        }
    },
    getRefreshToken(): string | null {
        return localStorage.getItem(STORAGE_KEYS.REFRESH)
    },
    setRefreshToken(token: string | null) {
        if (token === null) {
            localStorage.removeItem(STORAGE_KEYS.REFRESH)
        } else {
            localStorage.setItem(STORAGE_KEYS.REFRESH, token)
        }
    }
}

/**
 * 公共方法：setTokens, clearTokens, getAccessToken, logout
 */
export function setTokens({ accessToken, refreshToken }: { accessToken: string; refreshToken?: string }) {
    tokenStorage.setAccessToken(accessToken)
    if (refreshToken) {
        tokenStorage.setRefreshToken(refreshToken)
    }
}

export function clearTokens() {
    tokenStorage.setAccessToken(null)
    tokenStorage.setRefreshToken(null)
}

export function getAccessToken() {
    return tokenStorage.getAccessToken()
}

// 导出 TokenRefreshManager
export { TokenRefreshManager } from './tokenRefreshManager'
